/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ApiAttachmentStatusKind {
  Available = 'available',
  Deleted = 'deleted',
  Expired = 'expired',
  FailedUpload = 'failedUpload'
}
